import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Checkbox, Radio, Typography, withStyles } from "@material-ui/core";
import PaginadorApp from "app/Core/Components/Paginador/PaginadorApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import classNames from "classnames";
import MobileDetect from "mobile-detect";
import React from "react";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { MdMail, MdPhone, MdPhoneAndroid } from "react-icons/md";
import ReactTable from "react-table";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import TagBullet from "app/Core/Components/TagBullet/TagBullet";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        color: theme.palette.text.primary,
    }
});

class EmpresaPessoaTable extends XAPPComponent {


    handleChangeRadio = (event, item) => {
        var ASelected = this.props.selected;
        if (!this.isSelected(item.idpessoaformulario)) {
            var obj = item;
            obj["id"] = item.idpessoaformulario;
            obj["label"] = item.nome;
            if (!this.props.multiSelect)
                ASelected = [];
            ASelected.push(obj);
        }
        else {
            ASelected.splice(_.findIndex(ASelected, { id: item.idpessoaformulario }), 1);
        }
        this.props.onChange(ASelected);
    };

    isSelected = (id) => {
        var ASelected = this.props.selected;
        var AExists = false;
        ASelected.forEach((item) => {
            if (item.idpessoaformulario === id || item.id === id)
                AExists = true;
        });
        return AExists;
    };

    getColumns = (_AisLookup) => {
        const { selected, isLookup, multiSelect, onClick, disablePersonFields = false, showContatos = false, getTags } = this.props;
        var Columns = [
            {
                Header: "",
                width: 60,
                Cell: row => (
                    <div className="flex items-center">
                        {isLookup && row.original.statusregistro === 1 &&
                            <React.Fragment>
                                {multiSelect ?
                                    <Checkbox
                                        name="selected"
                                        checked={selected?.length > 0 && this.isSelected(row.original.idpessoaformulario)}
                                        onClick={event => {
                                            event.stopPropagation();
                                            this.handleChangeRadio(event, row.original);
                                        }}
                                    />
                                    :
                                    <Radio
                                        name="selected"
                                        checked={selected?.length > 0 && this.isSelected(row.original.idpessoaformulario)}
                                        onClick={event => {
                                            event.stopPropagation();
                                            this.handleChangeRadio(event, row.original);
                                        }}
                                    />
                                }
                            </React.Fragment>
                        }
                    </div>
                )
            },
            {
                className: "justify-center",
                expander: true,
                width: 60,
                show: showContatos,
                // eslint-disable-next-line react/prop-types
                Expander: ({ isExpanded, ...rest }) => {
                    if (this.existeContatos(rest.original)) {
                        return (
                            <XAPPButton
                                name="expanded"
                                type="Icon"
                                className="p-4"
                                iconProps={""}
                                icon={isExpanded ? "minus" : "add"}
                                key={"iconExpand"}
                                onClick={() => { }}
                            />
                        );
                    }
                    else {
                        return (
                            <div />
                        );
                    }
                }
            },
            {
                Header: "Nome",
                accessor: "nome",
                Cell: row => (
                    <div
                        className="flex w-full cursor-pointer h-full items-center"
                        onClick={() => onClick(row.original)}
                    >
                        {row.original.nome}
                    </div>
                )
            },
            {
                Header: "Aniversário",
                accessor: "mes",
                width: 160,
                show: !disablePersonFields,
                Cell: row => (
                    <div
                        className="flex w-full cursor-pointer h-full items-center justify-center"
                        onClick={() => onClick(row.original)}
                    >

                        {!_.isUndefined(row.original.formulario.nascimentoabertura) &&
                            !_.isNull(row.original.formulario.nascimentoabertura) &&
                            row.original.formulario.nascimentoabertura.length > 0 ?
                            row.original.formulario.nascimentoabertura.substring(8, 10) + "/" + row.original.formulario.nascimentoabertura.substring(5, 7) : ""}
                    </div>
                )
            },
            {
                Header: "Tags",
                accessor: "tags",
                width: 120,
                Cell: row => (
                    <div
                        className="flex w-full cursor-pointer h-full items-center"
                        onClick={() => onClick(row.original)}
                    >
                        <TagBullet
                            className="w-full ml-24 mb-4"
                            itens={getTags(row.original)}
                        />
                    </div>
                )
            },
            {
                Header: "Fone",
                accessor: "fone",
                show: false
            },
            {
                Header: "Celular",
                accessor: "celular",
                show: false
            },
            {
                Header: "Email",
                accessor: "email",
                show: false
            },
            {
                Header: "Facebook",
                accessor: "facebook",
                show: false
            },
            {
                Header: "Instagram",
                accessor: "instagram",
                show: false
            }
        ];
        if (!_AisLookup) {
            Columns.splice(0, 1);
        }
        return Columns;
    };

    existeContatos = (_AValue) => {
        return (
            (!_.isNull(_AValue.fone) && _AValue.fone !== "") ||
            (!_.isNull(_AValue.celular) && _AValue.celular !== "") ||
            (!_.isNull(_AValue.email) && _AValue.email !== "") ||
            (!_.isNull(_AValue.whatsapp) && _AValue.whatsapp !== "") ||
            (!_.isNull(_AValue.facebook) && _AValue.facebook !== "") ||
            (!_.isNull(_AValue.instagram) && _AValue.instagram !== ""));
    };

    render() {
        const { Pessoas, classes, isLookup, data, nextPage } = this.props;

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    className={classNames(classes.root, "cursor-pointer -striped -highlight border-0")}
                    data={data}
                    columns={this.getColumns(isLookup)}
                    SubComponent={(row) => (
                        <div className="sm:flex">
                            <div className="sm:w-1/2 xs:w-full">
                                {row.original.fone && row.original.fone.length > 0 &&
                                    <a
                                        style={{ textDecoration: "none" }}
                                        className="font-medium flex items-center p-8 ml-60"
                                        href={"tel:" + row.original.foneprefix + row.original.fone}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <MdPhone className="text-green text-20 mr-12" />
                                        <Typography className="text-16" color="textSecondary">{row.original.foneprefix + row.original.fone}</Typography>
                                    </a>
                                }
                                {row.original.celular && row.original.celular.length > 0 &&
                                    <a
                                        style={{ textDecoration: "none" }}
                                        className="font-medium flex items-center p-8 ml-60"
                                        href={"tel:" + row.original.celularprefix + row.original.celular}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <MdPhoneAndroid className="text-green text-20 mr-12" />
                                        <Typography className="text-16" color="textSecondary">{row.original.celularprefix + row.original.celular}</Typography>
                                    </a>
                                }
                                {row.original.whatsapp && row.original.whatsapp.length > 0 &&
                                    <a
                                        style={{ textDecoration: "none" }}
                                        className="font-medium flex items-center p-8 ml-60"
                                        href={"https://wa.me/" + row.original.whatsappprefix + row.original.whatsapp}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaWhatsapp className="text-green text-20 mr-12" />
                                        <Typography className="text-16" color="textSecondary">{row.original.whatsappprefix + row.original.whatsapp}</Typography>
                                    </a>
                                }
                            </div>
                            <div className="sm:w-1/2 xs:w-full">
                                {row.original.email && row.original.email.length > 0 &&
                                    <a
                                        style={{ textDecoration: "none" }}
                                        className="font-medium flex items-center p-8 ml-60"
                                        href={"mailto:" + row.original.email}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <MdMail className="text-yellow-dark text-20 mr-12" />
                                        <Typography className="text-16" color="textSecondary">{row.original.email}</Typography>
                                    </a>
                                }
                                {row.original.facebook && row.original.facebook.length > 0 &&
                                    <a
                                        style={{ textDecoration: "none" }}
                                        className="font-medium flex items-center p-8 ml-60"
                                        href={md.mobile() === null && md.tablet() === null ? ("https://www.facebook.com/" + row.original.facebook) : ("fb://profile/" + row.original.facebook)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaFacebook className="text-blue text-20 mr-12" />
                                        <Typography className="text-16" color="textSecondary">{row.original.facebook}</Typography>
                                    </a>
                                }
                                {row.original.instagram && row.original.instagram.length > 0 &&
                                    <a
                                        style={{ textDecoration: "none" }}
                                        className="font-medium flex items-center p-8 ml-60"
                                        href={md.mobile() === null && md.tablet() === null ? ("https://www.instagram.com/" + row.original.instagram) : ("instagram://user?username=" + row.original.instagram)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaInstagram className="text-purple text-20 mr-12" />
                                        <Typography className="text-16" color="textSecondary">{row.original.instagram}</Typography>
                                    </a>
                                }
                            </div>
                        </div>
                    )}
                    defaultPageSize={100}
                    noDataText="Não existem registros cadastrados!"
                    PaginationComponent={PaginadorApp}
                    nextPage={nextPage}
                    paginas={Pessoas.data ? Pessoas.data[0].paginas : 1}
                    pagina={Pessoas.pagina}
                />
            </FuseAnimate>
        );
    }
}


export default withStyles(styles, { withTheme: true })(EmpresaPessoaTable);
